import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { ProgressSpinner } from 'primereact/progressspinner';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import { SelectButton } from 'primereact/selectbutton';
import { Sidebar } from 'primereact/sidebar';
import { Toast } from 'primereact/toast';
import React from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './App.scss';
import { TipoExame } from './Assets/Enum/TipoExameEnum';
import { FlexConteiner, Item, ItemLabel, MainConteiner } from './Component/Conteiner/conteiner';
import CustomButton from './Component/CustomButton/custom-button';
import CustomTable from './Component/CustomTable/custom-table';
import CustomDropDown from './Component/DropDown/custom-dropdown';
import HamburguerMenu from './Component/HamburguerMenu/hamburguer-menu';
import { Header, Menu } from './Component/Header/header';
import Inform from './Component/Inform/inform';
import { PanelCalendar, ScheduleTitle } from './Component/Schedule/schedule';
import Spinner from './Component/Spinner/spinner';
import Doubt from './Pages/Doubt/doubt';
import Information from './Pages/Information/information';
import TestType from './Pages/TestType/test-type';
import { api } from './Services/drogal-api';

const enumBalance = {
  hasBalance: 'hasBalance',
  hasNoBalance: 'hasNoBalance',
  noCheck: 'noCheck'
}

const style = {
  modalDataDescription: {color: 'rgb(102,204,255)', fontSize:'14px'},
  modalMarginTopDescription: {marginTop:'-15px'},
  modalDataWidthDescription: {color: 'rgb(102,204,255)', fontSize:'14px', maxWidth:'200px'}
}

const DefaultCity = { label: "SELECIONE A CIDADE", value: 0}
const headerTable = [
  {
    field:'item_record',
    header:<><span style={{marginRight:'40px'}}>Horário</span><span>Local</span></>,
    name: 'initial',
    headerStyle:{  width: '500px', fontSize:'14px', borderRadius:'24px', paddingLeft:'30px' }
  }
]

const headerTableCanceSchedule = [
  {
    field:'item_record',
    header:<>
      <span style={{marginRight:'30px'}}>Dt. Hora</span>
      <span style={{marginRight:'105px'}}>Local</span>
      <span style={{marginRight:'95px'}}>Nome</span>
      <span>Teste</span>
    </>,
    name: 'initial',
    headerStyle:{  width: '500px', fontSize:'14px', borderRadius:'24px', paddingLeft:'30px' }
  }
]

const tokenType = {
  schedule: 'schedule',
  cancel: 'cancel',
  scheduleCancelGrid: 'scheduleCancelGrid'
}

const options = [  
  <div>Manhã</div>, 
  <div>Tarde</div>,
  <div>Noite</div>, 
  <div>Todos</div>
]

const canSchedule = (value) => {
  return value === null || value === 0
}

const handleButtonTipe = (value) => {
  return `p-button-rounded button-width ${value?'p-button-rounded p-button-outlined':'p-button-text'}`
}

const Detail = (props) => {
  return( 
      <div style={{paddingTop:'150px'}}>
          { props.children }
      </div>
  )
}

const ImgFooter = () => <a className='app-image-footer' href="https://www.drogal.com.br/melhores-marcas-drogal-cuidados-com-a-saude/?map=cl" />

const MenuLogo = () => <a className="app-image-logo" href="https://www.drogal.com.br"/> 

var interval = undefined;
const title = "Reenviar código"
const count = 25

class App extends React.PureComponent {

  constructor(props){
    super()
    this.state = {
      count: count,
      resendTitle: title,
      list:[],
      valueCalendar: new Date(),
      city: DefaultCity,
      cityList: [],
      scheduleDaily: [],
      records: [],
      modalDisplay: false,
      scheduleCancelmodalDisplay: false,
      modalDisplayCode: false,
      selectedItem: {},
      testType:[],
      periodFilterValue: options[3],
      scheduleSuccess: false,
      token: '',
      tokenCancel: '',
      telefoneCancel: '',
      SmsSent: false,
      waiting: false,
      waitingCancelSchedule: false,
      waitingCancelQuery: false,
      loadingScheduleCancel: false,
      scheduleCancelList: [],
      selectedMenu: {
        doubt: true,
        schedule: false,
        testTipe: false,
        info: false,
        telemedicina: false,
      },
      acceptTerms: false,
      spinnerPreToken: false,
      spinnerSave: false,
      spinnerReSend: false,
      spinnerSchedule: false,
      displaySidebar: false,
      hoverHover: false,
      checkingBalance: false,
      tokenTypeValue: '',
      idSchedule: '',
      scheduleCancelTextAlert: '',
      checkedBalance: enumBalance.noCheck

    }
    
    this.handleDate = this.handleDate.bind(this)
    this.handleSchedule = this.handleSchedule.bind(this)
    this.handleContent = this.handleContent.bind(this)
    this.handlePreSaveSchedule = this.handlePreSaveSchedule.bind(this)
    this.handleSave = this.handleSave.bind(this)
    this.handleLoadCities = this.handleLoadCities.bind(this)
    this.handleLoadTestType = this.handleLoadTestType.bind(this)
    this.handleToast = this.handleToast.bind(this)
    this.handleLiteralDate = this.handleLiteralDate.bind(this)
    this.inputValidate = this.inputValidate.bind(this)
    this.handleEmptyField = this.handleEmptyField.bind(this)
    this.handlePeriod = this.handlePeriod.bind(this)
    this.handleInfoColor = this.handleInfoColor.bind(this)
    this.renderFooter = this.renderFooter.bind(this)
    this.renderFooterCodeConfirm = this.renderFooterCodeConfirm.bind(this)
    this.onScheduleClick = this.onScheduleClick.bind(this)
    this.cancelSchedule = this.cancelSchedule.bind(this)
    this.handleCancelScheduleContent = this.handleCancelScheduleContent.bind(this)
    this.handleScheduleCancelList = this.handleScheduleCancelList.bind(this)    
    this.handleCancelSchedule = this.handleCancelSchedule.bind(this)
    this.handleScheduleCancelToken = this.handleScheduleCancelToken.bind(this)
    this.handleScheduleCancelGrid = this.handleScheduleCancelGrid.bind(this)
    this.handleExpirationToken = this.handleExpirationToken.bind(this)
    this.handleClearInterval = this.handleClearInterval.bind(this)    
  }

  handleClearInterval(force){
    if((this.state.count===0)||(force)){        
      clearInterval(interval);
      this.setState({...this.state, resendTitle: title, count: count})
    }
  }

  handleExpirationToken () {
    this.setState({...this.state, resendTitle: (this.state.count-1).toString(), count: this.state.count-1}, ()=>{
      this.handleClearInterval()
    })    
  }

  async handleScheduleCancelToken(){

    try{
      var response = await api.http.get(`${api.addresses.covidTest.enviarTokenCancelamentoPorSms}/${this.state.telefoneCancel.replace(/\D/g, "")}`)
      if(response.data.Sucesso){
        this.setState({ ...this.state,tokenTypeValue: tokenType.cancel})
      }                                    
    }catch{
      this.handleClearInterval(true)
      this.setState({...this.state, tokenTypeValue: ''})
      this.handleToast('error', 'Erro', "Erro ao cancelar agenda")
    }

  }

  cancelSchedule(){    
    this.setState({...this.state, modalDisplayCancelSchedule:true})  
  }

  onScheduleClick(){    
    let selectedMenu = {
      doubt:false,
      schedule:true,
      testTipe:false,
      info:false
    }
    this.setState({...this.state, selectedMenu})  
  }

  handlePeriod(list) { 
    
    let filtered = []
  
    if(this.state.periodFilterValue ===options[0]){
      filtered = list.filter(x=> x.horario <= '11:59')
    }

    if(this.state.periodFilterValue ===options[1]){
      filtered = list.filter(x=> x.horario >= '12:00' && x.horario <='17:59')
    }

    if(this.state.periodFilterValue ===options[2]){
      filtered = list.filter(x=> x.horario >= '18:00' && x.horario <='19:00')
    }

    if(this.state.periodFilterValue ===options[3]){
      filtered = list
    }

    return filtered
  }

  handleSchedule(value) {
    let dia = this.handleDate(new Date(value)).substr(0,2)
    let mes = this.handleDate(new Date(value)).substr(3,2)
    let ano = this.handleDate(new Date(value)).substr(6,4)

    this.setState({...this.state, records: [], spinnerSchedule: true})

    api.http.get(`${api.addresses.covidTest.consultaAgenda}/${this.state.city.value}/${dia}/${mes}/${ano}`)
      .then((res)=>{ 
        let records = []
        res.data.map(item => 
          records.push({ 
            item_record:( 
              <div className={canSchedule(item.Age_Situacao) ? "hover-avaiable" : ""}>
                <FlexConteiner className={ canSchedule(item.Age_Situacao) ? 'custom-data-table can-schedule' : 'custom-data-table cannot-schedule' }>
                  <Item style={{maxWidth:'90px', marginTop:'3px'}}>
                    <div className="border-right-item-table">
                      <i className="pi pi-clock" style={{marginRight:'10px'}}/>{ item.Age_Hora.toString().substr(0,5) } 
                    </div>
                  </Item>
                  <Item style={{marginTop:'3px'}}>
                    <div className="border-right-item-table">
                      { item.Fil_Nome } (<span style={{fontWeight:'bold', fontSize: '12px'}}>{item.Fil_Endereco}</span>)
                    </div>
                  </Item>
                  <Item style={{maxWidth:'120px'}}>
                    <CustomButton 
                        title={ canSchedule(item.Age_Situacao) ? <>&nbsp;&nbsp;&nbsp;Agendar&nbsp;&nbsp;&nbsp;</>: <>Indisponível</> } 
                        icon= { canSchedule(item.Age_Situacao) ? "pi pi-calendar-plus": "pi pi-calendar-minus" }
                        customStyle= { canSchedule(item.Age_Situacao) ? "primary": undefined }
                        disabled={ !canSchedule(item.Age_Situacao) }
                        onClick={ 
                          ()=> {                         
                            this.setState({...this.state, selectedItem: this.state.records.filter(x => x.codigo === item.Age_Codigo)[0] }, 
                            ()=> this.setState({...this.state, modalDisplay: true, checkingBalance: true, testType: [], checkedBalance: enumBalance.noCheck, tokenTypeValue: tokenType.schedule }, 
                              ()=> this.handleLoadTestType(item.Age_CodigoFilial)))
                          }
                        }
                      />
                  </Item>
                </FlexConteiner>
              </div>
            ),
            
            codigo: item.Age_Codigo,            
            horario:item.Age_Hora.toString().substr(0,5),
            data: item.Age_Data,
            codigoFilial: item.Age_CodigoFilial,
            filial: item.Fil_Nome.replace("FILIAL", ""),
            exame: { 
              label: "", 
              value: 0,
              price: 0
            },
            valor: (item.ET_Preco || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            nome: item.Age_Nome,
            telefone: item.Age_Celular,
            endereco_sms: `${item.Fil_Endereco}, ${item.Fil_Numero}, ${item.Fil_Bairro}, ${item.Fil_Cidade}/${item.Fil_Uf} @${item.Fil_Cep}`, 
            enderecoModal: (
              <div>
                { item.Fil_Nome } (<span style={{fontWeight:'bold', fontSize: '11px'}}>{item.Fil_Endereco}, {item.Fil_Numero}, {item.Fil_Bairro}, {item.Fil_Cidade}, {item.Fil_Uf} - {item.Fil_Cep}</span>)                
              </div>              
            )
          })
        )
      
        this.setState({...this.state, records: records, spinnerSchedule: false})
    })
    .catch(error => 
      this.setState({...this.state, spinnerSchedule: false})
    )
  }

  handleLoadCities(){
    api.http.get(api.addresses.covidTest.cities)
      .then((res)=>{
        let list = [DefaultCity]
        res.data.result.map(item => 
          list.push({ 
            label: item.Cidade, 
            value: item.Codigo
          })
        )
        this.setState({...this.state, cityList: list})
      })
  }
  
  handleLoadTestType(codigoFilial){
    
    let dia = this.handleDate(this.state.valueCalendar).substr(0,2)
    let mes = this.handleDate(this.state.valueCalendar).substr(3,2)
    let ano = this.handleDate(this.state.valueCalendar).substr(6,4)
    let data = `${ano}-${mes}-${dia}`
    let params = `${api.addresses.covidTest.tipoExame}/${codigoFilial.toString()}/${data}`

    api.http.get(params)
      .then((res)=>{
        let list = []    
        res.data.filter(item => item.ET_TipoExame ===	TipoExame.TesteCovid).map(item => 
          list.push({ 
            label: `${item.ET_Descricao} - ${item.ET_Preco.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`, 
            value: item.ET_Codigo,
            price: item.ET_Preco
          })
        )

        let checkedBalance = list.length === 0? enumBalance.hasNoBalance: enumBalance.hasBalance
        this.setState({...this.state, testType: list , checkedBalance: checkedBalance, checkingBalance: false})
      })      
  }

  inputValidate(value) {
    return value ? "p-invalid " : "" 
  }

  handleInfoColor = () =>{
    return (((this.state.selectedItem.exame !== undefined) && (this.state.selectedItem.exame.label !== "")) && 
            ((this.state.selectedItem.nome !== "") && (this.state.selectedItem.nome !== null)) && 
            ((this.state.selectedItem.telefone !== null) && (this.state.selectedItem.telefone !== ""))) ? 'red': 'gray'
  }

  handleDate(_date){ 
    let day = _date.getDate().toString().length === 1 ? '0'+_date.getDate().toString():_date.getDate().toString()
    let month = (_date.getMonth()+1).toString().length === 1 ? '0'+(_date.getMonth()+1).toString():(_date.getMonth()+1).toString()
    let year = _date.getFullYear().toString()

    return (day +'/'+ month +'/'+ year)
  }

  handleCancelScheduleContent(){ 
    return <>
      <FlexConteiner>
        <Item style={{ marginLeft: 3, paddingLeft: 3}} >
          <ItemLabel>Informe o Celular</ItemLabel>
          <InputMask 
            mask="(99) 99999-9999"
            id="id_celular" 
            style={{width:'100%'}}
            value={ this.state.telefoneCancel } 
            onChange={ (e)=> this.setState({...this.state, telefoneCancel: e.target.value}) }
          />
        </Item> 
        <Item style={{marginTop:'25px', maxWidth:'140px', minWidth:'140px', marginLeft: 5, paddingLeft: 5}}>
          <Button 
            iconPos="right" 
            icon={ this.state.waiting ? "" : "pi pi-arrow-circle-right" }
            label={<span>Enviar SMS {this.state.waiting && <ProgressSpinner style={{marginLeft:'10px', width: '15px', height: '15px'}}/>}</span> }
            className="p-button-rounded p-button-outlined p-button-secondary" 
            onClick={ ()=> { 
              try {
                if (this.state.telefoneCancel ==="") {  
                  this.handleToast('warn', 'Aviso', "Informe o número do celular")
                  return
                }

                this.setState({...this.state, SmsSent: false, waiting: true, tokenCancel:'', scheduleCancelList: [], scheduleCancelTextAlert: ""}, 
                  async() => {
                    var response = await api.http.get(`${api.addresses.covidTest.enviarTokenCancelamentoPorSms}/${this.state.telefoneCancel.replace(/\D/g, "")}`)
                    if(response.data.Sucesso){
                      this.setState({
                        ...this.state, 
                        SmsSent: true, 
                        waiting: false, 
                        tokenTypeValue: tokenType.scheduleCancelGrid, 
                        modalDisplayCode: true
                      })

                      try{
                        document.getElementById("id_code").focus();
                        document.getElementById("id_code").select();
              
                        var input = document.getElementById("id_code");
                        input.addEventListener('keypress', function (e) {
                          if (e.key === 'Enter') {
                            document.getElementById("id_send_code").click();          
                          }
                        });
                      }catch{}
                    }
                    else{
                      this.setState({...this.state, waiting: false, scheduleCancelTextAlert: 'Não existe agenda para o número informado'})
                      this.handleToast('warn', 'Aviso', response.data)
                    }
                  }
                )                
              } catch {
                this.setState({...this.state, waiting: false})
                this.handleToast('error', 'Erro', "Erro ao enviar SMS")
              }
            }
          } />
        </Item>        
      </FlexConteiner >
      {/* <FlexConteiner>
        <Item style={{marginLeft: 3, paddingLeft: 3}}>          
          <ItemLabel style={{fontSize:'13px'}}>Código SMS</ItemLabel> 
          <input
            disabled={ !this.state.SmsSent }
            maxLength={6}
            id="id_code"
            placeholder="000000"
            style={{width:'100%', fontSize:'30px', textAlign:'left', color: 'gray', border:'solid 1px hsl(0,0%,80%)', paddingLeft:'15px'}} 
            value={ this.state.tokenCancel } 
            onChange={ (e)=> this.setState({...this.state, tokenCancel: e.target.value})}
          />  
        </Item>
        <Item style={{marginTop:'21px', maxWidth:'140px', minWidth:'140px', marginLeft: 5, paddingLeft: 5}}>
          <Button 
            disabled={ !this.state.SmsSent }
            iconPos="right" 
            icon={ this.state.waitingCancelQuery ?"": "pi pi-arrow-circle-right" }
            label={<span>&nbsp;Consultar&nbsp;&nbsp;{this.state.waitingCancelQuery && <ProgressSpinner style={{marginLeft:'10px', width: '15px', height: '15px'}}/>}</span> }
            className="p-button-rounded p-button-outlined p-button-secondary" 
            onClick={ ()=>{
              try{

                if( this.state.telefoneCancel===''){
                  this.handleToast('warn', 'Aviso', "Informe o número do celular")
                  return
                }

                this.setState({...this.state, loadingScheduleCancel: true, waitingCancelQuery: true}, 
                  async()=>{                    
                    var url = `${api.addresses.covidTest.consultaAgendaCancelamento}/${this.state.telefoneCancel.replace(/\D/g, "")}/${this.state.tokenCancel}`
                    var response = await api.http.get(url)
                    var scheduleCancelList = this.handleScheduleCancelList(response)
                    this.setState({...this.state, scheduleCancelList: scheduleCancelList, loadingScheduleCancel: false, waitingCancelQuery: false})  
                  })                                
              }catch{                 
              }
            }}
          />
        </Item>
      </FlexConteiner> */}

      <FlexConteiner>          
        <Item style={{maxWidth:'100%', marginLeft:0}}>            
            {this.state.scheduleCancelTextAlert !== "" && <div style={{textAlign:'center', marginTop:'20px'}}><Message severity="warn" text={ this.state.scheduleCancelTextAlert } /></div>}
            {this.state.scheduleCancelTextAlert === "" && 
              <CustomTable 
                header={ this.state.loadingScheduleCancel ? <span>Carregando agenda...</span> : "Horários agendados"}
                records={ this.state.scheduleCancelList } 
                listColumns={ headerTableCanceSchedule }
              />
            }
        </Item>
      </FlexConteiner>
    </>;
  }

  handleScheduleCancelList(valueList){
    
    let records = []
    valueList.data.map(item => 
      records.push({        
      Age_Codigo: item.Age_Codigo,
      item_record:( 
        <FlexConteiner className="custom-data-table can-schedule" style={{alignItems: 'center'}}>
          <Item className="border-right-item-table"  style={{fontSize:'12px', maxWidth:'75px'}}>
            { this.handleDate(new Date(item.Age_Data)) } { item.Age_Hora.toString().substr(0,5) } Hrs
          </Item>
          <Item style={{fontSize:'12px', maxWidth:'130px'}}>              
            { `${item.Fil_Nome}, ${item.Fil_Endereco}, ${item.Fil_Numero}, ${item.Fil_Bairro}, ${item.Fil_Cidade}/${item.Fil_Uf}` }              
          </Item>
          <Item style={{fontSize:'12px', maxWidth:'160px'}}>
            { item.Age_Nome }
          </Item>
          <Item className="border-right-item-table" style={{fontSize:'12px'}}>
            { item.ET_Descricao }              
          </Item>
          <Item style={{fontSize:'15px', maxWidth:'60px'}}>              
            <Button 
              icon="pi pi-trash"
              className="p-button-text p-button-danger" 
              style={{fontSize:'13px', marginLeft:'2px', marginRight:'2px'}}
              onClick={ async()=>{
                try{                     
                  var response = await api.http.get(`${api.addresses.covidTest.enviarTokenCancelamentoPorSms}/${this.state.telefoneCancel.replace(/\D/g, "")}`)
                  if(response.data.Sucesso){
                    this.setState({
                      ...this.state,  
                        modalDisplayCode: true,
                        tokenTypeValue: tokenType.cancel, 
                        idSchedule: item.Age_Codigo
                    })

                    try{
                      document.getElementById("id_code").focus();
                      document.getElementById("id_code").select();
            
                      var input = document.getElementById("id_code");
                      input.addEventListener('keypress', function (e) {
                        if (e.key === 'Enter') {
                          document.getElementById("id_send_code").click();          
                        }
                      });
                    } catch {

                    }
                  }                                    
                } catch {
                  this.setState({...this.state, 
                    waitingCancelSchedule: false,
                    tokenTypeValue: '', 
                    idSchedule: ''
                  })

                  this.handleToast('error', 'Erro', "Erro ao enviar token")
                }
              }}
            />              
          </Item>
        </FlexConteiner>               
      )        
    }))   

    return records
  }

  handleContent(){
    return (
      <>
        {!this.state.scheduleSuccess ?
          <>
            <FlexConteiner>
              <Item style={ style.modalDataDescription }>
                <ItemLabel>{this.state.selectedItem.enderecoModal}</ItemLabel>              
              </Item>              
            </FlexConteiner>
            <FlexConteiner style={style.modalMarginTopDescription}>
              <Item style={ style.modalDataWidthDescription }>
                <ItemLabel>Data: {this.handleDate(this.state.valueCalendar)}</ItemLabel>              
              </Item>
              <Item style={ style.modalDataDescription }>
                <ItemLabel>Horário: {this.state.selectedItem.horario}</ItemLabel>              
              </Item>              
            </FlexConteiner>            
            <FlexConteiner>              
              <Item>
                {this.state.checkingBalance ? 
                  <div style={{ paddingBottom:'5px' }}><Spinner/>
                    <ItemLabel style={{ marginLeft:'25px', marginTop:'-5px', fontSize:'13px' }}>Verificando disponibilidade de testes em estoque...</ItemLabel>
                  </div>
                :  this.state.checkedBalance === enumBalance.hasNoBalance ?                    
                  <ItemLabel style={{color:'#FF3333'}}>Não existe teste disponível no momento</ItemLabel>
                : <ItemLabel>Teste</ItemLabel>}
                 
                
                <CustomDropDown
                  options={this.state.testType}
                  value={this.state.selectedItem.exame}
                  onChange={ (e)=> {
                    let selectedItem = { ...this.state.selectedItem }
                    selectedItem.exame = e
                    this.setState({...this.state, selectedItem: selectedItem})} }              
                />
              </Item>          
            </FlexConteiner>
            <FlexConteiner>
              <Item>
                <ItemLabel>Nome completo</ItemLabel>
                <InputText 
                    id="id_cliente"
                    style={{width:'100%', textTransform: 'uppercase'}} 
                    value={ this.state.selectedItem.nome } 
                    onChange={ (e)=> {
                      let selectedItem = { ...this.state.selectedItem }
                      selectedItem.nome = e.target.value
                      this.setState({...this.state, selectedItem: selectedItem})} }
                  />
              </Item>          
            </FlexConteiner>
            <FlexConteiner>
              <Item>
                <ItemLabel>Celular</ItemLabel>
                <InputMask 
                    mask="(99) 99999-9999"
                    id="id_celular" 
                    style={{width:'100%'}}
                    value={ this.state.selectedItem.telefone } 
                    onChange={ (e)=> {
                      let selectedItem = { ...this.state.selectedItem }
                      selectedItem.telefone = e.target.value
                      this.setState({...this.state, selectedItem: selectedItem})} }              
                  />
              </Item>                    
            </FlexConteiner>
            <FlexConteiner>
              <Item style={{fontSize: '12px', color: this.handleInfoColor()}}>
                <p style={{color:"red"}}>
                  *Os testes disponíveis na Drogal podem não ser válidos para viagens. 
                  Verifique com a agência de viagem, com o país de destino e/ou local 
                  de viagem e com a companhia de viagem(aérea, marítima ou rodoviária) 
                  qual o tipo de teste é exigido para a detecção de Coronavírus.
                  {/* *Os testes disponíveis neste site não são válidos para viagens internacionais.
                  Verifique com a companhia aérea e país de destino qual o tipo de 
                  teste é exigido para a detecção de Coronavírus. */}
                </p>
                <div className="p-field-checkbox">
                <label>
                  <Checkbox 
                    value={this.state.acceptTerms}  
                    checked={this.state.acceptTerms} 
                    onChange={ ()=> this.setState({...this.state, acceptTerms: !this.state.acceptTerms})}/>
                  &nbsp;Eu li e aceito</label>
                </div>
              </Item>          
            </FlexConteiner>
          </>:
            <FlexConteiner>
              <Item>
                <div style={{textAlign:'center'}}>
                  <i className="pi pi-calendar" style={{ fontSize: '12em', color:'hsl(0,0%,80%)'}}/>
                  <i className="pi pi-check p-mr-2" style={{ zIndex:1, position: 'fixed', marginLeft: '-165px', fontSize: '12em', color: 'rgb(102,204,102)'}}/>
                  <div style={{ fontSize: '25px', color: 'rgb(102,204,102)', marginTop:'12px'}}>Seu teste foi agendado com sucesso ;)</div>
                </div>
              </Item>
            </FlexConteiner>
          }
      </>
    )
  }
  
  renderFooter = () =>{
    return (
      <div>
        {!this.state.scheduleSuccess ?
        <FlexConteiner>
          <Item>
            <Button 
              label={<>&nbsp;&nbsp;&nbsp;Cancelar&nbsp;&nbsp;&nbsp;</>}
              onClick={ ()=> this.setState({...this.state, modalDisplay: false, acceptTerms: false, spinnerSave: false, spinnerPreToken: false}) }
              className="p-button-rounded p-button-outlined p-button-secondary" 
            />
            <Button 
              className={`p-button-rounded ${this.state.acceptTerms? 'p-button-success': ''}`}
              label={<>&nbsp;&nbsp;Confirmar&nbsp;&nbsp;</>}
              onClick={ ()=> this.handlePreSaveSchedule()}
              disabled={ !this.state.acceptTerms }
              autoFocus 
            >
              { this.state.spinnerSave && <Spinner style={{ marginRight:'10px', marginTop:'-20px' } }/> }
            </Button>  
          </Item>
        </FlexConteiner>:
          <Button 
            className='p-button-rounded p-button-success'
            label={<>&nbsp;&nbsp;&nbsp;Fechar&nbsp;&nbsp;&nbsp;</>}
            onClick={ ()=> this.setState({...this.state, modalDisplay: false, scheduleSuccess: false, acceptTerms: false}) }
            autoFocus 
          />
        }
      </div>
    );
  }
  
  renderFooterCodeConfirm = () =>{
    return (
        <div style={{textAlign:'center'}}>
          <Button
            className="p-button-rounded p-button-outlined p-button-primary" 
            label={<>&nbsp;&nbsp;&nbsp;Cancelar&nbsp;&nbsp;&nbsp;</>}
            onClick={ async ()=> {
              try{ 
                if(this.state.tokenTypeValue === tokenType.schedule)
                  await api.http.get(`${api.addresses.covidTest.cancelarPreToken}/${this.state.selectedItem.telefone.replace(/\D/g, "")}`)                
              }finally{
                this.setState({...this.state, token: '', modalDisplayCode: false})
              }
              
            }}                         
          />
          <Button 
            id="id_send_code"
            className="p-button-rounded p-button-success"            
            label={<>&nbsp;&nbsp;Confirmar&nbsp;&nbsp;</>}
            onClick={ ()=> {
              if(this.state.tokenTypeValue === tokenType.schedule)
                this.handleSave()
              if(this.state.tokenTypeValue === tokenType.scheduleCancelGrid)
                this.handleScheduleCancelGrid()
              else  
                this.handleCancelSchedule()
            }}
            disabled={ this.state.token ==="" }
            autoFocus 
          >
            { this.state.spinnerPreToken && <Spinner style={{ marginRight:'10px', marginTop:'-20px' } }/> }
          </Button>  
        </div>
    );
  }

  handleEmptyField(value) {
    return ((value === "") || (value === null) || (value === undefined))
  }

  async handlePreSaveSchedule(reSend) {
    try{  

      let toSave = true
      if((this.handleEmptyField(this.state.selectedItem.nome))||
        (this.handleEmptyField(this.state.selectedItem.telefone))||
        (this.state.selectedItem.exame.value === 0)){
          toSave = false
      }

      if(toSave){
        
        if (reSend){
          this.setState({...this.state, spinnerReSend: true})
        }else{
          this.setState({...this.state, spinnerSave: true})
        }

        let result = await api.http.get(`${api.addresses.covidTest.enviarTokenPorSms}/${this.state.selectedItem.codigo}/${this.state.selectedItem.telefone.replace(/\D/g, "")}`)
        
        if(result.status === 202){          
          this.handleToast('error', 'Erro', result.data)
          if (reSend){
            this.setState({...this.state, spinnerReSend: false})
          }else{
            this.setState({...this.state, spinnerSave: false})
          }         
        }else{
          if (reSend){
            this.setState({...this.state, spinnerReSend: false})
          }else{
            this.setState({...this.state, token: '', modalDisplayCode: true, spinnerSave: false})
          }
          document.getElementById("id_code").focus();
          document.getElementById("id_code").select();

          var input = document.getElementById("id_code");
          input.addEventListener('keypress', function (e) {
            if (e.key === 'Enter') {
              document.getElementById("id_send_code").click();          
            }
          });
        }
      }else{
        this.handleToast('warn', 'Aviso', 'Obrigatório o preenchimento de todos os dados')
        if (reSend){
          this.setState({...this.state, spinnerReSend: false})
        }else{
          this.setState({...this.state, spinnerSave: false})
        }
      }
    } catch(e) {
      this.handleClearInterval(true)
      this.handleToast('error', 'Erro ao realizar agendamento', 'Aguarde alguns minutos e tente novamente')

      if (reSend){
        this.setState({...this.state, spinnerReSend: false})
      } else {
        this.setState({...this.state, spinnerSave: false})
      }
    }
  }

  async handleScheduleCancelGrid(){

    try{

      if( this.state.telefoneCancel===''){
        this.handleToast('warn', 'Aviso', "Informe o número do celular")
        return
      }

      this.setState({...this.state, loadingScheduleCancel: true, waitingCancelQuery: true}, 
        async()=>{                    
          var url = `${api.addresses.covidTest.consultaAgendaCancelamento}/${this.state.telefoneCancel.replace(/\D/g, "")}/${this.state.token}`
          var response = await api.http.get(url)
          var scheduleCancelList = this.handleScheduleCancelList(response)
          this.setState({
            ...this.state, 
            scheduleCancelList: scheduleCancelList, 
            loadingScheduleCancel: false, 
            waitingCancelQuery: false, 
            modalDisplayCode: false, 
            token: ''
          })
        })                                
    }catch{                 
    }

  }

  async handleCancelSchedule(){
    try{
      this.setState({...this.state, waitingCancelSchedule: true}, async() => { 
        var response = await api.http.get(`${api.addresses.covidTest.cancelarAgenda}/${this.state.idSchedule}/${this.state.token}/${this.state.telefoneCancel.replace(/\D/g, "")}`)
        if (response.data.Sucesso) { 

          var scheduleCancelList = this.state.scheduleCancelList
          scheduleCancelList = scheduleCancelList.filter(x=>x.Age_Codigo !== this.state.idSchedule)

          this.setState({...this.state, waitingCancelSchedule: false, scheduleCancelList: scheduleCancelList, modalDisplayCode: false, token: '' },
            ()=> this.handleToast('success', 'Sucesso', response.data.Mensagem))
        }
        else{
          this.setState({...this.state, waitingCancelSchedule: false},
            ()=> this.handleToast('warn', 'Aviso', response.data.Mensagem))
        }
      })
    }catch{
      this.handleToast('error', 'Erro', 'Erro ao cancelar agenda')
    }
  }

  async handleSave(){ 
    try { 
      this.setState({...this.state, spinnerPreToken: true})

      let result = await api.http.post(api.addresses.covidTest.gravarAgenda, {
        Codigo: this.state.selectedItem.codigo,
        Nome: this.state.selectedItem.nome,
        Telefone: this.state.selectedItem.telefone.replace(/\D/g, ""),
        TipoExame: this.state.selectedItem.exame.value,
        Token: this.state.token,
        Agendamento: ( 
          `@@${this.state.selectedItem.exame.label}@
            @Local: ${this.state.selectedItem.endereco_sms}@
            @Data: ${ this.handleDate(this.state.valueCalendar) }
            @Hora: ${ this.state.selectedItem.horario }`)
      })
    
      if(result.status === 202){
        this.handleToast('error', 'Erro ao realizar agendamento', result.data)
        this.setState({...this.state, spinnerPreToken: false})
      }else{
        this.setState({...this.state, token:"", scheduleSuccess: true, modalDisplayCode: false, spinnerPreToken: false}, 
          ()=> this.handleSchedule(this.state.valueCalendar)
        )
      }      
    }catch(e){
      console.log(e)
        this.handleToast('error', 'Erro ao realizar agendamento', 'Aguarde alguns minutos e tente novamente')
        this.setState({...this.state, spinnerPreToken: false})
    }
  }

  handleToast(severity, summary, detail){
    this.toast.show(
      {
        severity: severity, 
        summary: summary, 
        detail: detail
      }
    );
  }

  handleLiteralDate(value){
    const days = [{name:'Sat', value:'Sábado'},{name:'Fri', value:'Sexta'},{name:'Thu', value:'Quinta'},{name:'Wed', value:'Quarta'},{name:'Tue', value:'Terça'},{name:'Mon', value:'Segunda'},{name:'Sun', value:'Domingo'}]
    const month = [{name:'Jan', value:'de Janeiro de'}, {name:'Feb', value:'de Fevereiro de'},{name:'Mar', value:'de Março de'},{name:'Apr', value:'de Abril de'},{name:'May', value:'de Maio de'},{name:'Jun', value:'de Junho de'},{name:'Jul', value:'de Julho de'},{name:'Aug', value:'de Agosto de'},{name:'Sep', value:'de Setembro de'},{name:'Oct', value:'de Outubro de'},{name:'Nov', value:'de Novembro de'},{name:'Dec', value:'de Dezembro de'}]

    let result = value.toString().replace('GMT','')
    result = result.substring(0,result.indexOf(':')-3);
    days.map(item => result = result.replace(item.name, item.value))      
    month.map(item => result = result.replace(item.name, item.value))
    
    result = result.split(" ")
    return `${result[0]}, ${result[4]} de ${result[2]} de ${result[5]}`
  }

  componentDidMount(){
    this.handleLoadCities()      
    // this.handleLoadTestType()
    
    this.handleSchedule(this.state.valueCalendar)
  }
  render(){
    return (
      <div className="App" >        
          <Toast ref={(el) => this.toast = el}/>          
          <Header>          
            <MainConteiner>            
              <Menu>
                <HamburguerMenu onClick={()=> this.setState({...this.state, displaySidebar: !this.state.displaySidebar}) }/>
                <MenuLogo/>
                {/* <Item className="menu-width">
                  <Button label="Telemedicina" className={ handleButtonTipe(this.state.selectedMenu.telemedicina) } 
                    onClick={ ()=> { window.open( api.addresses.covidTest.telemedicina,'_self')} }
                  />           
                </Item> */}
                <Item className="menu-width">
                  <Button label="Dúvidas" className={ handleButtonTipe(this.state.selectedMenu.doubt) } 
                    onClick={()=> {
                      let selectedMenu = {
                        doubt:true,
                        schedule:false,
                        testTipe:false,
                        info:false
                      }
                    this.setState({...this.state, selectedMenu})}}
                  />           
                </Item>                  
                <Item className="menu-width">
                  <Button label="Tipos de teste" className={ handleButtonTipe(this.state.selectedMenu.testTipe) }
                    onClick={()=> {
                      let selectedMenu = {
                        doubt:false,
                        schedule:false,
                        testTipe:true,
                        info:false
                      }
                      this.setState({...this.state, selectedMenu})}}
                  />  
                </Item>
                <Item className="menu-width">
                  <Button label="Informação" className={ handleButtonTipe(this.state.selectedMenu.info) }
                    onClick={()=> {
                      let selectedMenu = {
                        doubt:false,
                        schedule:false,
                        testTipe:false,
                        info:true
                      }
                      this.setState({...this.state, selectedMenu})}}
                  />  
                </Item>
                <Item className="menu-width">
                  <Button label="Agendar teste" className="Primary p-button-rounded button-blue button-width"
                    // onClick={ ()=> { window.open( api.addresses.covidTest.whatssApp,'_blank')}}
                    onClick={()=> {
                      let selectedMenu = {
                        doubt:false,
                        schedule:true,
                        testTipe:false,
                        info:false
                      }
                      this.setState({...this.state, selectedMenu})}}
                  />                    
                </Item>
              </Menu>
            </MainConteiner>            
          </Header>
          <Detail>
            {this.state.selectedMenu.schedule &&
              <MainConteiner>
                <Item className="conteiner-max-width">
                  <ScheduleTitle>Agendamento</ScheduleTitle>
                    <Calendar
                      onChange={(e)=> this.setState({...this.state, records: [], spinnerSchedule: true, valueCalendar: e}, this.handleSchedule(e))} 
                      value={this.state.valueCalendar}/>
                  <PanelCalendar>
                    <SelectButton 
                      value={this.state.periodFilterValue} 
                      onChange={(e)=>  this.setState({...this.state, periodFilterValue: e.target.value})}
                      options={options}  
                    />
                  </PanelCalendar> 
                </Item>  
                
                <Item style={{maxWidth:'100%'}}>
                  <div className="drodown-search">
                    <CustomDropDown
                      defaultValue="SP"
                      options={this.state.cityList}
                      value={this.state.city}
                      onChange={(e) => {
                        this.setState({...this.state, city: e}, ()=> this.handleSchedule(this.state.valueCalendar))
                      }}                  
                    />    
                  </div>
                    <br/> 
                    {this.state.spinnerSchedule && 
                      <div style={{textAlign:'center'}}><Spinner style={{ marginRight:'10px' } }/></div> 
                    }
                  
                    { this.state.records.length === 0 ?      
                      <div className="app-image-covid"/> :
                        <CustomTable 
                          header={this.handleLiteralDate(this.state.valueCalendar)}
                          records={ this.handlePeriod(this.state.records) } 
                          listColumns={ headerTable }
                        />
                    }                  
                </Item>

                <Item className="conteiner-max-width-info">
                  <Inform 
                    onClick1={()=> {
                      let selectedMenu = {
                        doubt:true,
                        schedule:false,
                        testTipe:false,
                        info:false
                      }
                    this.setState({...this.state, selectedMenu})}} 
                    onClick2={()=> {
                      let selectedMenu = {
                        doubt:false,
                        schedule:false,
                        testTipe:true,
                        info:false
                      }
                    this.setState({...this.state, selectedMenu})}}
                    onClick3={()=> {
                      let selectedMenu = {
                        doubt:false,
                        schedule:false,
                        testTipe:true,
                        info:false
                      }
                    this.setState({...this.state, selectedMenu})}} 
                    onClick4={()=> {
                      let selectedMenu = {
                        doubt:false,
                        schedule:false,
                        testTipe:false,
                        info:true
                      }
                    this.setState({...this.state, selectedMenu})}}
                    onClick5={()=> this.cancelSchedule()}
                  /> 
                </Item>
                <ImgFooter />
              </MainConteiner>}
              <Doubt 
                show={ this.state.selectedMenu.doubt }
                onBannerClick={()=> {
                  let selectedMenu = {
                    doubt:false,
                    schedule:false,
                    testTipe:false,
                    info:true
                  }
                  this.setState({...this.state, selectedMenu, displaySidebar: false})}
                } 
                onClick={ ()=> this.onScheduleClick() } 
                onClick1={()=> {
                  let selectedMenu = {
                    doubt:true,
                    schedule:false,
                    testTipe:false,
                    info:false
                  }
                this.setState({...this.state, selectedMenu})}} 
                onClick2={()=> {
                  let selectedMenu = {
                    doubt:false,
                    schedule:false,
                    testTipe:true,
                    info:false
                  }
                this.setState({...this.state, selectedMenu})}}
                onClick3={()=> {
                  let selectedMenu = {
                    doubt:false,
                    schedule:false,
                    testTipe:true,
                    info:false
                  }
                this.setState({...this.state, selectedMenu})}} 
                onClick4={()=> {
                  let selectedMenu = {
                    doubt:false,
                    schedule:false,
                    testTipe:false,
                    info:true
                  }
                this.setState({...this.state, selectedMenu})}}
                onClick5={()=> this.cancelSchedule()}
              />
              <TestType 
                show={ this.state.selectedMenu.testTipe } 
                onTestClick={()=> {
                  let selectedMenu = {
                    doubt:false,
                    schedule:true,
                    testTipe:false,
                    info:false
                  }
                this.setState({...this.state, selectedMenu})}} 
                onClick={ ()=> this.onScheduleClick() }
                onClick1={()=> {
                  let selectedMenu = {
                    doubt:true,
                    schedule:false,
                    testTipe:false,
                    info:false
                  }
                this.setState({...this.state, selectedMenu})}} 
                onClick2={()=> {
                  let selectedMenu = {
                    doubt:false,
                    schedule:false,
                    testTipe:true,
                    info:false
                  }
                this.setState({...this.state, selectedMenu})}}
                onClick3={()=> {
                  let selectedMenu = {
                    doubt:false,
                    schedule:false,
                    testTipe:true,
                    info:false
                  }
                this.setState({...this.state, selectedMenu})}} 
                onClick4={()=> {
                  let selectedMenu = {
                    doubt:false,
                    schedule:false,
                    testTipe:false,
                    info:true
                  }
                this.setState({...this.state, selectedMenu})}}
                onClick5={()=> this.cancelSchedule()}
              />
              <Information 
                show={ this.state.selectedMenu.info }
                onClick1={()=> {
                  let selectedMenu = {
                    doubt:true,
                    schedule:false,
                    testTipe:false,
                    info:false
                  }
                this.setState({...this.state, selectedMenu})}} 
                onClick2={()=> {
                  let selectedMenu = {
                    doubt:false,
                    schedule:false,
                    testTipe:true,
                    info:false
                  }
                this.setState({...this.state, selectedMenu})}}
                onClick3={()=> {
                  let selectedMenu = {
                    doubt:false,
                    schedule:false,
                    testTipe:true,
                    info:false
                  }
                this.setState({...this.state, selectedMenu})}} 
                onClick4={()=> {
                  let selectedMenu = {
                    doubt:false,
                    schedule:false,
                    testTipe:false,
                    info:true
                  }
                this.setState({...this.state, selectedMenu})}}
                onClick5={()=> this.cancelSchedule()}
              />             
          </Detail>
          <Dialog 
            modal 
            header="Cancelar Agenda"
            visible={this.state.modalDisplayCancelSchedule} 
            className="app-schedule-dialog" 
            footer={ 
              <div>                
                <Button 
                  className="Primary p-button-rounded button-blue button-width"
                  label={<>&nbsp;&nbsp;&nbsp;Fechar&nbsp;&nbsp;&nbsp;</>}
                  onClick={ ()=> this.setState({
                    ...this.state, 
                    modalDisplayCancelSchedule: false, 
                    telefoneCancel: '', 
                    tokenCancel: '', 
                    scheduleCancelList: [], 
                    waiting: false, 
                    SmsSent: false, 
                    scheduleCancelTextAlert: ''
                  }) }
                  autoFocus
                />        
              </div> 
            } 
            onHide={ ()=>this.setState({...this.state, modalDisplayCancelSchedule: false, scheduleCancelList: []}) }
          >
            { this.handleCancelScheduleContent() }                   
          </Dialog>
          <Dialog 
            modal 
            header="Agendamento de exame"
            visible={this.state.modalDisplay} 
            className="app-schedule-dialog" 
            footer={ this.renderFooter() } 
            onHide={ ()=>this.setState({...this.state, modalDisplay: false}) }
          >
            { this.handleContent() }                   
          </Dialog>

          <Dialog 
            modal 
            header={<div style={{marginLeft:'15px', textAlign:'center'}}>Informe o código enviado por SMS no celular</div>}            
            visible={ this.state.modalDisplayCode }
            className="app-code-dialog" 
            footer={ this.renderFooterCodeConfirm() }
          >
            <FlexConteiner>
              <Item>
                <input
                  maxLength={6}
                  id="id_code"
                  placeholder="000000"
                  focused
                  style={{width:'100%', fontSize:'60px', textAlign:'center', color: 'gray', border:'solid 1px hsl(0,0%,80%)'}} 
                  value={ this.state.token } 
                  onChange={ (e)=> this.setState({...this.state, token: e.target.value}) }
                />              
              </Item>
            </FlexConteiner>
            {this.state.spinnerReSend && <FlexConteiner style={{textAlign:'center'}}>
              <Item>              
                <Spinner style={{ marginRight:'10px' } }/>
              </Item>
            </FlexConteiner>}
            <FlexConteiner style={{textAlign:'center'}}>
              <Item>              
                <a onClick={ ()=> {

                  if( this.state.resendTitle === title ){
                    interval = setInterval(this.handleExpirationToken, 1000);
                    
                    if(this.state.tokenTypeValue === tokenType.schedule)
                      this.handlePreSaveSchedule(true) 
                    else  
                      this.handleScheduleCancelToken()  
                  }
                    
                  }} href="#">{ this.state.resendTitle }</a>
              </Item>
            </FlexConteiner>            
          </Dialog>
          
          <Sidebar 
            visible={this.state.displaySidebar} 
            baseZIndex={1000000} 
            onHide={() => this.setState({...this.state, displaySidebar: false})}
          >
            <div className="sidebar-conteiner">

              {/* <Button label="Telemedicina" className="p-button-text"
                onClick={ ()=> { window.open( api.addresses.covidTest.telemedicina,'_self')} }
              /> */}
              
              <Button label="Dúvidas" className="p-button-text" 
                onClick={()=> {
                  let selectedMenu = {
                    doubt:true,
                    schedule:false,
                    testTipe:false,
                    info:false
                  }
                this.setState({...this.state, selectedMenu, displaySidebar: false})}}
              />
              
              <Button label="Tipo de teste" className="p-button-text" 
                onClick={()=> {
                  let selectedMenu = {
                    doubt:false,
                    schedule:false,
                    testTipe:true,
                    info:false
                  }
                this.setState({...this.state, selectedMenu, displaySidebar: false})}}
              />

              <Button label="Informação" className="p-button-text" 
                onClick={()=> {
                  let selectedMenu = {
                    doubt:false,
                    schedule:false,
                    testTipe:false,
                    info:true
                  }
                this.setState({...this.state, selectedMenu, displaySidebar: false})}}
              />   

              <Button label="Agendar teste" className="p-button-text" 
                // onClick={ ()=> { window.open( api.addresses.covidTest.whatssApp,'_blank')}}
                onClick={()=> {
                  let selectedMenu = {
                    doubt:false,
                    schedule:true,
                    testTipe:false,
                    info:false
                  }
                this.setState({...this.state, selectedMenu, displaySidebar: false})}}
              />
            
            </div>
            
          </Sidebar>
          
      </div>
    )
  }
}

export default App;
